/**
 * useSettingsScrollSpy — tracks which settings section is currently visible.
 *
 * Uses IntersectionObserver with a tight rootMargin so only the section
 * nearest the top of the viewport fires as "active". On section change,
 * pushes `#sectionId` to the browser history without triggering Vue Router.
 */
import { ref, onMounted, onBeforeUnmount } from 'vue';
export function useSettingsScrollSpy(sectionIds) {
    const activeSection = ref(sectionIds[0] ?? 'profile');
    let observer = null;
    function onIntersect(entries) {
        for (const entry of entries) {
            if (entry.isIntersecting) {
                const id = entry.target.id;
                if (sectionIds.includes(id)) {
                    activeSection.value = id;
                    // Push hash without Vue Router navigation
                    history.replaceState(null, '', `#${id}`);
                }
            }
        }
    }
    onMounted(() => {
        observer = new IntersectionObserver(onIntersect, {
            // "-80px 0px -80% 0px": fires when the top of a section crosses ~top 20% of viewport
            rootMargin: '-80px 0px -80% 0px',
            threshold: 0,
        });
        for (const id of sectionIds) {
            const el = document.getElementById(id);
            if (el)
                observer.observe(el);
        }
    });
    onBeforeUnmount(() => {
        observer?.disconnect();
        observer = null;
    });
    function scrollTo(id) {
        const el = document.getElementById(id);
        if (el) {
            const top = el.getBoundingClientRect().top + window.scrollY - 88;
            window.scrollTo({ top, behavior: 'smooth' });
        }
    }
    return { activeSection, scrollTo };
}
